<template>
  <div>
    <div class="flex-box search bb">
      <div class="flex-box flex-h-v flex1 mr10 br inputContent">
        <input class="searchInput" type="number" v-model="sendData.clubId" placeholder="输入俱乐部ID">
        <div class="closeBtn" v-show="sendData.clubId" @click="clear"></div>
      </div>
      <div class="flex1 flex-box flex-v-c">
        <div class="flex1 button searchBtn" @click="search">查询</div>
        <div class="flex1 flex-box flex-v-c flex-b button sort" @click="sortSwitch">
          <span v-show="sendData.order===1">报备时间降序</span>
          <span v-show="sendData.order==2">报备时间升序</span>
          <i class="iconfont" :class="{iconXiajiantou:!sortListShow,iconShangjiantou:sortListShow}"></i>
        </div>
      </div>
      <transition name="transUp">
        <div class="overView" v-show="sortListShow" @click="sortSwitch">
          <ul class="sortList">
            <li class="flex-box flex-v-c bb" @click.stop="sort(1)">
              报备时间降序
              <i class="trueIcon" v-show="sendData.order===1"></i>
            </li>
            <li class="flex-box flex-v-c" @click.stop="sort(2)">
              报备时间升序
              <i class="trueIcon" v-show="sendData.order==2"></i>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <Cloadmore @loadBottom="loadBottom" @loadTop="loadTop" ref="listTopic">
      <ul v-if="list.length>0" v-cloak>
        <li v-for="(item,index) in list" @click="details(item.id)" class="bb" :key="item.id">
          <div class="flex-box flex-v-c club">
            <div class="flex1">
              <div>
                亲友圈ID：
                <span class="tip">{{item.clubIds}}</span>
              </div>
              <div>
                圈主昵称：
                <span>{{item.nickname}}</span>
              </div>
            </div>
          </div>
          <div class="flex-box flex-v-c">
            场次数：
            <span class="amColor">{{item.awardPlayCount}}</span>
          </div>
          <div>第{{['','一','二','三'][item.stage]}}阶段应发时间：{{item.sendAwardTime}}</div>
          <div>场次奖励时间段：{{item.startTime}}-{{item.endTime}}</div>

          <i class="iconfont icon-more more"></i>
        </li>
      </ul>
      <div v-else class="nullData">暂无数据~</div>
    </Cloadmore>
    <transition name="trans">
      <detail :id="detailId" class="detail" v-if="detailShow" @ctrDetails="ctrDetails"></detail>
    </transition>
  </div>
</template>
<!--javascript-->
<script>
import Cloadmore from '../loadmore/loadmore.vue'
import detail from './detail.vue'
export default {
  components: { Cloadmore, detail },
  data: function () {
    return {
      loader: false,
      list: [],
      sortListShow: false,//控制显示隐藏
      sendData: {
        clubId: '',
        lastIndex: '',
        limit: 10,
        order: 1
      },
      detailShow: false,
      detailId: ''
    }
  },
  methods: {
    getData(params) {
      let that = this;
      that.$http.get('/award/list', {
        params: that.sendData
      }).then(function (res) {
        if (res.code == 0) {
          that.loader = true;
          that.dataLength = res.data.length;
          if (that.dataLength > 0) {
            that.sendData.lastIndex = res.data[that.dataLength - 1].id
            for (let i = 0; i < that.dataLength; i++) {
              that.list.push(res.data[i])
            }

            if (params == 'getNewData') {
              for (let i = 0; i < that.dataLength; i++) {
                that.list[i] = res.data[i]
              }
              that.list.length = that.dataLength
            }
          } else {
            that.$refs.listTopic.setAllLoaded(true);
            that.$toast({
              message: '没有更多数据', position: 'bottom'
            });
          }
        } else {
          that.$toast(res.message)
        }
      })
    },
    loadTop() {
      let that = this;
      that.sendData.lastIndex = '';
      that.sendData.clubId = '';
      that.getData('getNewData')
      setTimeout(function () {
        that.$refs.listTopic.onTopLoaded()
      }, 1000);
      that.$refs.listTopic.setAllLoaded(false)
    },
    loadBottom() {
      let that = this;
      if (!that.loader) {
        return
      }
      // that.sendData.index += 1;
      setTimeout(function () {
        that.$refs.listTopic.onBottomLoaded();
      }, 1000);
      that.getData()
    },
    search() {
      if (!this.sendData.clubId) {
        this.$toast('请输入亲友圈ID')
        return
      }
      this.sendData.lastIndex = '';
      this.getData('getNewData')
      // this.details(this.sendData.clubId)
    },
    input() {
    },
    clear() {
      this.sendData.clubId = '';
      this.sendData.lastIndex = '';
      this.getData('getNewData')
    },
    sort(params) {
      this.sendData.order = params;
      this.sendData.lastIndex = '';
      this.sendData.clubId = '';
      this.getData('getNewData')
      this.sortSwitch()
    },
    sortSwitch() {
      this.sortListShow = !this.sortListShow
    },
    ctrDetails(params) {
      this.detailShow = params;
    },
    details(id) {
      this.detailId = id;
      this.ctrDetails(true)
    }
  },
  mounted: function () {
    this.getData()
  },
  created: function () {
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
* {
  margin: 0;
  padding: 0;
}

ul {
  li {
    line-height: 1.5;
    padding: 10px;
    position: relative;
    min-height: 1.2rem;
  }
}

.closeBtn {
  height: 100%;
}
.searchBtn {
  height: 0.6rem;
  margin: 0 2px 0 4px;
}

.inputContent {
  position: relative;
}

.searchInput {
  width: 100%;
  text-align: center;
}

.search {
  height: 0.8rem;
  position: relative;
}

.club {
  margin-bottom: 10px;
}

.sort {
  padding: 4px 0px;
  height: 0.6rem;
  margin: 0 2px 0 4px;
  .iconfont {
    font-size: 0.1rem;
    margin-top: 2px;
    margin-left: 3px;
  }
}

.overView {
  position: absolute;
  width: 100%;
  height: calc(100vh - 1.7rem);
  background: rgba(0, 0, 0, 0.5);
  top: 0.8rem;
  left: 0;
  z-index: 1;
}

ul.sortList {
  position: absolute;
  width: 100%;
  background: #fff;
  top: 0;
  left: 0;
  z-index: 2;
  li {
    padding: 0 10px;
    position: relative;
    min-height: 0.7rem;
    .trueIcon {
      position: absolute;
      right: 0;
      top: 50%;
      -webkit-transform: translate3d(-50%, -50%, 0);
      transform: translate3d(-50%, -50%, 0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/awardProgress/index.vue